/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-04 14:55:37                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-14 12:03:36                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * ContactInfoCard: display contact entity informations
*/

/* Imports */
import { Card, CardBody, Typography } from "@material-tailwind/react";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";
/***/

/**
* ContactInfoCard: display contact entity informations
* @param contact - contact data
*/
export default function ContactInfoCard({
  contact,
  onClear
}: {
  contact: EasyTech.Contact,
  onClear?: () => void
}) {
  return (
    <Card className="m-3 shadow-none border rounded-lg border-gray-300 relative">
      {onClear && (
        <button
          type="button"
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
          onClick={onClear}
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      )}
      <CardBody className="flex flex-col">
        <Typography variant={"h6"} className="mb-2 pr-6">
          { contact.firstName+" "+contact.lastName }
        </Typography>

        <div className="flex gap-2">
          <div className="flex items-center justify-center">
            <EnvelopeIcon className="h-[20px] w-[20px] text-gray-400"/>
          </div>

          <Typography>
            {contact.contactInfo && contact.contactInfo.email ? contact.contactInfo.email : t("common:noEmail")}
          </Typography>
        </div>
        
        <div className="flex gap-2">
          <div className="flex items-center justify-center">
            <PhoneIcon className="h-[20px] w-[20px] text-gray-400"/>
          </div>

          <Typography>
            {contact.contactInfo && contact.contactInfo.phone ? contact.contactInfo.phone : t("common:noPhone")}
          </Typography>
        </div>
      </CardBody>
    </Card>
  );
}
/***/
